import { ColDef, GridReadyEvent, ICellRendererParams } from 'ag-grid-community'
import { getPaymentHistory } from 'api/subscription'
import { PLACEHOLDER } from 'components/column-renderers'
import dateRenderer from 'components/column-renderers/date'
import InfinityAgGrid from 'components/table/InfinityAgGrid'
import { getPlanLabel } from 'features/Subscription/constants'
import { UIModal } from 'features/UI'
import React from 'react'
import { useQuery } from 'react-query'
import { PaymentHistoryRow, SubscriptionPlanType } from 'types'

const PAYMENT_STATUS_LABEL: Record<string, string> = {
  paid: 'Paid',
  open: 'Failed',
  draft: 'Draft',
  void: 'Canceled',
  uncollectible: 'Uncollectible',
  PROMO_ACTIVE: 'Active',
  PROMO_INACTIVE: 'Inactive',
  NOT_AVAILABLE: PLACEHOLDER,
}

const columnDefs: ColDef[] = [
  {
    headerName: 'Payment Date',
    cellRenderer: dateRenderer('paymentDate'),
    colId: 'paymentDate',
    flex: 1,
  },
  {
    headerName: 'Plan Type',
    field: 'planType',
    flex: 1,
    minWidth: 250,
    cellRenderer: (props: ICellRendererParams<PaymentHistoryRow>) => {
      if (!props.data?.planType) return PLACEHOLDER
      return getPlanLabel(props.data.planType as SubscriptionPlanType)
    },
  },
  {
    headerName: 'Status',
    field: 'status',
    flex: 1,
    cellRenderer: (props: ICellRendererParams<PaymentHistoryRow>) => {
      if (!props.data?.status) return PLACEHOLDER
      return PAYMENT_STATUS_LABEL[props.data.status] ?? props.data.status
    },
  },
  {
    headerName: 'Payment Method',
    field: 'paymentMethod',
    flex: 1,
  },
]

export function SubscriptionCaregiverDetailsModal({
  userId,
  isOpen,
  onClose,
}: {
  userId: number
  isOpen: boolean
  onClose: () => void
}) {
  const { data, isLoading } = useQuery({
    queryKey: ['payment-history', userId],
    queryFn: () => getPaymentHistory({ userId }),
    enabled: isOpen && userId != null,
  })

  const paymentHistory: PaymentHistoryRow[] = data?.data.paymentHistory ?? []

  const handleGridReady = (event: GridReadyEvent) => {
    event.api.sizeColumnsToFit()
  }

  return (
    <UIModal isOpen={isOpen} onClose={onClose} width={920} title="Payment History">
      <div
        className="ag-theme-alpine"
        style={{ height: '400px', width: '870px', fontSize: '1rem' }}
      >
        <InfinityAgGrid
          rowData={isLoading ? undefined : paymentHistory}
          columnDefs={columnDefs}
          rowModelType="clientSide"
          onGridReady={handleGridReady}
          floatingFiltersHeight={0}
        />
      </div>
    </UIModal>
  )
}
